import { Peer } from "@/utils/peer"
import { Remote } from "comlink"
import { deferSingleton } from "@/utils/defer-singleton"

function getGlobalObject(): any {
	return "undefined" != typeof window
		? window
		: "undefined" != typeof global
			? global
			: "undefined" != typeof self
				? self
				: {}
}

export function registerSentryDebugIds(debugIdMap: {
	[fileStack: string]: string
}): string | undefined {
	const globalObject = getGlobalObject()

	try {
		globalObject._sentryDebugIds = globalObject._sentryDebugIds || {}
		for (const fileStack in debugIdMap) {
			globalObject._sentryDebugIds[fileStack] = debugIdMap[fileStack]
		}
		return JSON.stringify(globalObject._sentryDebugIds)
	} catch (err) {
		// non-critical error, silently fail
	}
}

export function registerPeerForDebugIdSynchronization(options: {
	symbol: symbol
	peer: Remote<Peer>
}): void {
	const globalObject = getGlobalObject()

	try {
		globalObject._polarr_peers = globalObject._polarr_peers || {}
		globalObject._polarr_peers[options.symbol] = options.peer
	} catch (err) {
		// non-critical error, silently fail
	}
}

export function removePeerForDebugIdSynchronization(symbol: symbol): void {
	const globalObject = getGlobalObject()

	try {
		globalObject._polarr_peers = globalObject._polarr_peers || {}
		delete globalObject._polarr_peers[symbol]
	} catch (err) {
		// non-critical error, silently fail
	}
}

export const synchronizeDebugIdMapWithAllPeers = deferSingleton(async function (
	debugIdMapStringified: string,
): Promise<void> {
	const globalObject = getGlobalObject()

	try {
		globalObject._polarr_peers = globalObject._polarr_peers || {}
		for (const key of Object.getOwnPropertySymbols(globalObject._polarr_peers)) {
			await (globalObject._polarr_peers[key] as Remote<Peer>).updateDebugIdMap(
				debugIdMapStringified,
			)
		}
	} catch (err) {
		// non-critical error, silently fail
	}
}, 100)
